import { http } from "@/http/http.js";
export default {
  //查询账号菜单
  listAccountMenu(params) {
    return http.post("/web/accountManage/listMenu", params);
  },
  //上传文件
  commonUploadFile(pathName, param) {
    return http.postFile("/common/upload/" + pathName, "", param);
  },
  //文件下载
  downloadTemplate(params) {
    return http.get("/common/template/1", params);
  },
  //查询地域范围
  queryRoadList(params) {
    return http.post("/common/queryRoadList", params);
  },
  //保存地域范围
  saveRoad(params) {
    return http.post("/common/saveRoad", params);
  },
  //保存地域范围
  streetGeomInfo(params) {
    return http.post("/web/gis/streetGeomInfo", params);
  },
};
